// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    color: #0a0a0a;
    line-height: 1.5;
    overflow-x: hidden;
    background: #fff;
}

.about-page .container {
    max-width: 1180px;
    margin: 0 auto;
    padding: 0 24px;
}

/* Hero Section */
.about-hero {
    background-color: #e9f2ff;
    padding: 24px 0 100px;
    min-height: 600px;
    display: flex;
    align-items: center;
}

.hero-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 120px;
    width: 100%;
}

.hero-text {
    flex: 1 1;
    max-width: 500px;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.hero-text h4 {
    font-size: 50px;
    font-weight: 900;
    line-height: 0.95;
    margin-bottom: 32px;
    color: #000;
    letter-spacing: -3px;
    text-align: left;
}

.hero-text p {
    font-size: 21px;
    color: #333;
    margin-bottom: 48px;
    max-width: 480px;
    line-height: 1.4;
    font-weight: 500;
    text-align: left;
}

.btn-primary {
    background-color: #2b65f6;
    color: white;
    padding: 15px 40px;
    border-radius: 50px;
    font-weight: 500;
    font-size: 18px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-block;
    text-decoration: none;
    box-shadow: 0 4px 14px 0 rgba(43, 101, 246, 0.39);
}

.btn-primary:hover {
    background-color: #1d4ed8;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);
}

.hero-images {
    flex: 1 1;
    display: flex;
    justify-content: flex-end;
}

.image-grid {
    display: grid;
    grid-template-columns: 280px 240px;
    grid-template-rows: 200px 180px;
    gap: 20px;
}

.grid-item {
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.grid-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.item1 {
    grid-column: 1;
    grid-row: 1;
}

.item2 {
    grid-column: 2;
    grid-row: 1 / 3;
    height: 100%;
}

.item3 {
    grid-column: 1;
    grid-row: 2;
}

/* Mission Section */
.about-mission {
    padding: 120px 0;
}

.mission-content {
    display: flex;
    align-items: center;
    gap: 100px;
}

.mission-text {
    flex: 1 1;
}

.mission-text h2 {
    font-size: 32px;
    font-weight: 700;
    line-height: 1.3;
    margin-bottom: 30px;
}

.mission-text p {
    color: #555;
    margin-bottom: 24px;
    font-size: 18px;
    line-height: 1.6;
}

.mission-image {
    flex: 1 1;
}

.video-thumb {
    position: relative;
    border-radius: 30px;
    overflow: hidden;
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.1);
}

.video-thumb img {
    width: 100%;
    display: block;
}

.play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    background: #ff0000;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    transition: transform 0.3s ease;
}

.play-btn svg {
    width: 40px;
}

.play-btn:hover {
    transform: translate(-50%, -50%) scale(1.1);
}

/* How it Works */
.how-it-works {
    background-color: #f7f9fc;
    padding: 120px 0;
    text-align: center;
}

.section-title {
    font-size: 48px;
    font-weight: 800;
    margin-bottom: 80px;
}

.section-title span {
    color: #2563eb;
}

.steps-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
}

.step-card {
    background: transparent;
    padding: 40px;
    text-align: left;
}

.step-num {
    width: 60px;
    height: 60px;
    background: #2563eb;
    color: white;
    font-size: 24px;
    font-weight: 800;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
}

.step-card h3 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 20px;
}

.step-card p {
    color: #666;
    font-size: 16px;
    line-height: 1.6;
}

/* Shaping Future */
.shaping-future {
    padding: 120px 0;
}

.shaping-content {
    display: flex;
    align-items: center;
    gap: 80px;
}

.shaping-text {
    flex: 1 1;
}

.shaping-text h2 {
    font-size: 42px;
    font-weight: 800;
    margin-bottom: 30px;
    line-height: 1.1;
}

.shaping-image {
    flex: 1 1;
}

.road-trip-card {
    position: relative;
    border-radius: 30px;
    overflow: hidden;
}

.road-trip-card img {
    width: 100%;
    display: block;
}

.card-overlay {
    position: absolute;
    top: 40px;
    left: 40px;
    color: white;
}

.card-overlay h3 {
    font-size: 48px;
    font-weight: 800;
    margin: 0;
    line-height: 1.1;
    max-width: 300px;
}

/* History Section */
.company-history {
    background-color: #1a1a1a;
    color: white;
    padding: 120px 0;
}

.history-content {
    display: flex;
    align-items: center;
    gap: 100px;
}

.history-text {
    flex: 1 1;
}

.history-text h2 {
    font-size: 42px;
    font-weight: 800;
    margin-bottom: 40px;
}

.history-text p {
    color: #aaa;
    margin-bottom: 30px;
    font-size: 18px;
    line-height: 1.7;
}

.history-image {
    flex: 1 1;
    display: flex;
    justify-content: flex-end;
}

.history-image img {
    width: 100%;
    max-width: 500px;
    border-radius: 40px;
}

/* Testimonial */
.main-testimonial {
    background-color: #111;
    color: white;
    padding: 140px 0;
    text-align: center;
}

.testimonial-box {
    max-width: 900px;
    margin: 0 auto;
}

.testimonial-box p {
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 60px;
    line-height: 1.4;
}

.author {
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 10px;
}

.role {
    color: #666;
    font-size: 16px;
}

/* Mission Cards */
.mission-cards {
    padding: 120px 0;
    text-align: center;
}

.section-sub {
    color: #666;
    font-size: 18px;
    margin-bottom: 80px;
}

.cards-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
}

.mission-card {
    background: transparent;
    padding: 20px;
    text-align: left;
}

.quote-icon {
    font-size: 80px;
    color: #eee;
    line-height: 1;
    margin-bottom: -20px;
    font-family: serif;
}

.mission-card p {
    font-size: 18px;
    color: #444;
    margin-bottom: 30px;
    line-height: 1.6;
    position: relative;
    z-index: 1;
}

.card-author {
    font-weight: 700;
    font-size: 16px;
}

/* Goals Section */
.goals-section {
    padding: 0 20px;
    margin-bottom: 100px;
}

.goals-section .container {
    background: black;
    background-image: radial-gradient(circle at 2px 2px, #333 1px, transparent 0);
    background-size: 40px 40px;
    border-radius: 40px;
    padding: 120px 60px;
    text-align: center;
    color: white;
}

.goals-content {
    max-width: 800px;
    margin: 0 auto;
}

.goals-content h2 {
    font-size: 56px;
    font-weight: 800;
    margin-bottom: 30px;
    line-height: 1;
}

.goals-content p {
    font-size: 20px;
    color: #888;
    margin-bottom: 50px;
}

.btn-light {
    background: white;
    color: black;
    padding: 18px 50px;
    border-radius: 40px;
    font-weight: 700;
    font-size: 18px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
}

/* Bottom Links */
.bottom-links {
    padding: 100px 0;
    background: #e9f2ff;
}

.links-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 60px;
}

.link-col {
    border-left: 1px solid #2563eb;
    padding-left: 30px;
}

.link-col h3 {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 30px;
    line-height: 1.2;
}

.link-col a {
    color: #0a0a0a;
    text-decoration: none;
    font-weight: 600;
    font-size: 16px;
    border-bottom: 1px solid #0a0a0a;
    padding-bottom: 2px;
}

@media (max-width: 968px) {

    .hero-content,
    .mission-content,
    .shaping-content,
    .history-content {
        flex-direction: column;
        text-align: center;
    }

    .hero-text p {
        margin: 0 auto 32px;
    }

    .hero-images,
    .mission-image,
    .shaping-image,
    .history-image {
        width: 100%;
    }

    .steps-grid,
    .cards-grid,
    .links-grid {
        grid-template-columns: 1fr;
    }

    /* Mobile spacing & size reductions to remove huge gaps */
    .about-hero {
        padding: 40px 0;
        min-height: auto;
    }
    .about-mission,
    .how-it-works,
    .shaping-future,
    .company-history,
    .mission-cards,
    .bottom-links {
        padding: 40px 0;
    }
    .main-testimonial {
        padding: 50px 0;
    }
    .goals-section {
        margin-bottom: 40px;
    }
    .goals-section .container {
        padding: 50px 20px;
        border-radius: 24px;
    }
    .hero-text h4 {
        font-size: 32px;
        margin-bottom: 16px;
        letter-spacing: -1px;
    }
    .hero-text p {
        font-size: 16px;
        margin-bottom: 24px;
    }
    .section-title {
        font-size: 28px;
        margin-bottom: 30px;
    }
    .section-sub {
        margin-bottom: 30px;
    }
    .steps-grid,
    .cards-grid,
    .links-grid {
        gap: 20px;
    }
    .step-card,
    .mission-card {
        padding: 20px 10px;
    }
    .testimonial-box p {
        font-size: 20px;
        margin-bottom: 30px;
    }
    .goals-content h2 {
        font-size: 28px;
        margin-bottom: 16px;
    }
    .goals-content p {
        font-size: 15px;
        margin-bottom: 24px;
    }
    .hero-content {
        gap: 40px;
    }
    .mission-content,
    .shaping-content,
    .history-content {
        gap: 30px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/About.css"],"names":[],"mappings":"AAAA;IACI,yGAAyG;IACzG,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,WAAW;AACf;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,SAAO;IACP,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,+BAA+B;IAC/B,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2CAA2C;AAC/C;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,6EAA6E;IAC7E,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;;IAEI;;;;QAII,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;;;QAII,WAAW;IACf;;IAEA;;;QAGI,0BAA0B;IAC9B;;IAEA,yDAAyD;IACzD;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;;;;;;QAMI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;;;QAGI,SAAS;IACb;IACA;;QAEI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,SAAS;IACb;IACA;;;QAGI,SAAS;IACb;AACJ","sourcesContent":[".about-page {\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    color: #0a0a0a;\n    line-height: 1.5;\n    overflow-x: hidden;\n    background: #fff;\n}\n\n.about-page .container {\n    max-width: 1180px;\n    margin: 0 auto;\n    padding: 0 24px;\n}\n\n/* Hero Section */\n.about-hero {\n    background-color: #e9f2ff;\n    padding: 24px 0 100px;\n    min-height: 600px;\n    display: flex;\n    align-items: center;\n}\n\n.hero-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 120px;\n    width: 100%;\n}\n\n.hero-text {\n    flex: 1;\n    max-width: 500px;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.hero-text h4 {\n    font-size: 50px;\n    font-weight: 900;\n    line-height: 0.95;\n    margin-bottom: 32px;\n    color: #000;\n    letter-spacing: -3px;\n    text-align: left;\n}\n\n.hero-text p {\n    font-size: 21px;\n    color: #333;\n    margin-bottom: 48px;\n    max-width: 480px;\n    line-height: 1.4;\n    font-weight: 500;\n    text-align: left;\n}\n\n.btn-primary {\n    background-color: #2b65f6;\n    color: white;\n    padding: 15px 40px;\n    border-radius: 50px;\n    font-weight: 500;\n    font-size: 18px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: inline-block;\n    text-decoration: none;\n    box-shadow: 0 4px 14px 0 rgba(43, 101, 246, 0.39);\n}\n\n.btn-primary:hover {\n    background-color: #1d4ed8;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);\n}\n\n.hero-images {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.image-grid {\n    display: grid;\n    grid-template-columns: 280px 240px;\n    grid-template-rows: 200px 180px;\n    gap: 20px;\n}\n\n.grid-item {\n    border-radius: 24px;\n    overflow: hidden;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n}\n\n.grid-item img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.item1 {\n    grid-column: 1;\n    grid-row: 1;\n}\n\n.item2 {\n    grid-column: 2;\n    grid-row: 1 / 3;\n    height: 100%;\n}\n\n.item3 {\n    grid-column: 1;\n    grid-row: 2;\n}\n\n/* Mission Section */\n.about-mission {\n    padding: 120px 0;\n}\n\n.mission-content {\n    display: flex;\n    align-items: center;\n    gap: 100px;\n}\n\n.mission-text {\n    flex: 1;\n}\n\n.mission-text h2 {\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 1.3;\n    margin-bottom: 30px;\n}\n\n.mission-text p {\n    color: #555;\n    margin-bottom: 24px;\n    font-size: 18px;\n    line-height: 1.6;\n}\n\n.mission-image {\n    flex: 1;\n}\n\n.video-thumb {\n    position: relative;\n    border-radius: 30px;\n    overflow: hidden;\n    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.1);\n}\n\n.video-thumb img {\n    width: 100%;\n    display: block;\n}\n\n.play-btn {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 80px;\n    height: 80px;\n    background: #ff0000;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    cursor: pointer;\n    transition: transform 0.3s ease;\n}\n\n.play-btn svg {\n    width: 40px;\n}\n\n.play-btn:hover {\n    transform: translate(-50%, -50%) scale(1.1);\n}\n\n/* How it Works */\n.how-it-works {\n    background-color: #f7f9fc;\n    padding: 120px 0;\n    text-align: center;\n}\n\n.section-title {\n    font-size: 48px;\n    font-weight: 800;\n    margin-bottom: 80px;\n}\n\n.section-title span {\n    color: #2563eb;\n}\n\n.steps-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 40px;\n}\n\n.step-card {\n    background: transparent;\n    padding: 40px;\n    text-align: left;\n}\n\n.step-num {\n    width: 60px;\n    height: 60px;\n    background: #2563eb;\n    color: white;\n    font-size: 24px;\n    font-weight: 800;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 30px;\n}\n\n.step-card h3 {\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 20px;\n}\n\n.step-card p {\n    color: #666;\n    font-size: 16px;\n    line-height: 1.6;\n}\n\n/* Shaping Future */\n.shaping-future {\n    padding: 120px 0;\n}\n\n.shaping-content {\n    display: flex;\n    align-items: center;\n    gap: 80px;\n}\n\n.shaping-text {\n    flex: 1;\n}\n\n.shaping-text h2 {\n    font-size: 42px;\n    font-weight: 800;\n    margin-bottom: 30px;\n    line-height: 1.1;\n}\n\n.shaping-image {\n    flex: 1;\n}\n\n.road-trip-card {\n    position: relative;\n    border-radius: 30px;\n    overflow: hidden;\n}\n\n.road-trip-card img {\n    width: 100%;\n    display: block;\n}\n\n.card-overlay {\n    position: absolute;\n    top: 40px;\n    left: 40px;\n    color: white;\n}\n\n.card-overlay h3 {\n    font-size: 48px;\n    font-weight: 800;\n    margin: 0;\n    line-height: 1.1;\n    max-width: 300px;\n}\n\n/* History Section */\n.company-history {\n    background-color: #1a1a1a;\n    color: white;\n    padding: 120px 0;\n}\n\n.history-content {\n    display: flex;\n    align-items: center;\n    gap: 100px;\n}\n\n.history-text {\n    flex: 1;\n}\n\n.history-text h2 {\n    font-size: 42px;\n    font-weight: 800;\n    margin-bottom: 40px;\n}\n\n.history-text p {\n    color: #aaa;\n    margin-bottom: 30px;\n    font-size: 18px;\n    line-height: 1.7;\n}\n\n.history-image {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.history-image img {\n    width: 100%;\n    max-width: 500px;\n    border-radius: 40px;\n}\n\n/* Testimonial */\n.main-testimonial {\n    background-color: #111;\n    color: white;\n    padding: 140px 0;\n    text-align: center;\n}\n\n.testimonial-box {\n    max-width: 900px;\n    margin: 0 auto;\n}\n\n.testimonial-box p {\n    font-size: 32px;\n    font-weight: 500;\n    margin-bottom: 60px;\n    line-height: 1.4;\n}\n\n.author {\n    font-weight: 700;\n    font-size: 20px;\n    margin-bottom: 10px;\n}\n\n.role {\n    color: #666;\n    font-size: 16px;\n}\n\n/* Mission Cards */\n.mission-cards {\n    padding: 120px 0;\n    text-align: center;\n}\n\n.section-sub {\n    color: #666;\n    font-size: 18px;\n    margin-bottom: 80px;\n}\n\n.cards-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 40px;\n}\n\n.mission-card {\n    background: transparent;\n    padding: 20px;\n    text-align: left;\n}\n\n.quote-icon {\n    font-size: 80px;\n    color: #eee;\n    line-height: 1;\n    margin-bottom: -20px;\n    font-family: serif;\n}\n\n.mission-card p {\n    font-size: 18px;\n    color: #444;\n    margin-bottom: 30px;\n    line-height: 1.6;\n    position: relative;\n    z-index: 1;\n}\n\n.card-author {\n    font-weight: 700;\n    font-size: 16px;\n}\n\n/* Goals Section */\n.goals-section {\n    padding: 0 20px;\n    margin-bottom: 100px;\n}\n\n.goals-section .container {\n    background: black;\n    background-image: radial-gradient(circle at 2px 2px, #333 1px, transparent 0);\n    background-size: 40px 40px;\n    border-radius: 40px;\n    padding: 120px 60px;\n    text-align: center;\n    color: white;\n}\n\n.goals-content {\n    max-width: 800px;\n    margin: 0 auto;\n}\n\n.goals-content h2 {\n    font-size: 56px;\n    font-weight: 800;\n    margin-bottom: 30px;\n    line-height: 1;\n}\n\n.goals-content p {\n    font-size: 20px;\n    color: #888;\n    margin-bottom: 50px;\n}\n\n.btn-light {\n    background: white;\n    color: black;\n    padding: 18px 50px;\n    border-radius: 40px;\n    font-weight: 700;\n    font-size: 18px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n/* Bottom Links */\n.bottom-links {\n    padding: 100px 0;\n    background: #e9f2ff;\n}\n\n.links-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 60px;\n}\n\n.link-col {\n    border-left: 1px solid #2563eb;\n    padding-left: 30px;\n}\n\n.link-col h3 {\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: 30px;\n    line-height: 1.2;\n}\n\n.link-col a {\n    color: #0a0a0a;\n    text-decoration: none;\n    font-weight: 600;\n    font-size: 16px;\n    border-bottom: 1px solid #0a0a0a;\n    padding-bottom: 2px;\n}\n\n@media (max-width: 968px) {\n\n    .hero-content,\n    .mission-content,\n    .shaping-content,\n    .history-content {\n        flex-direction: column;\n        text-align: center;\n    }\n\n    .hero-text p {\n        margin: 0 auto 32px;\n    }\n\n    .hero-images,\n    .mission-image,\n    .shaping-image,\n    .history-image {\n        width: 100%;\n    }\n\n    .steps-grid,\n    .cards-grid,\n    .links-grid {\n        grid-template-columns: 1fr;\n    }\n\n    /* Mobile spacing & size reductions to remove huge gaps */\n    .about-hero {\n        padding: 40px 0;\n        min-height: auto;\n    }\n    .about-mission,\n    .how-it-works,\n    .shaping-future,\n    .company-history,\n    .mission-cards,\n    .bottom-links {\n        padding: 40px 0;\n    }\n    .main-testimonial {\n        padding: 50px 0;\n    }\n    .goals-section {\n        margin-bottom: 40px;\n    }\n    .goals-section .container {\n        padding: 50px 20px;\n        border-radius: 24px;\n    }\n    .hero-text h4 {\n        font-size: 32px;\n        margin-bottom: 16px;\n        letter-spacing: -1px;\n    }\n    .hero-text p {\n        font-size: 16px;\n        margin-bottom: 24px;\n    }\n    .section-title {\n        font-size: 28px;\n        margin-bottom: 30px;\n    }\n    .section-sub {\n        margin-bottom: 30px;\n    }\n    .steps-grid,\n    .cards-grid,\n    .links-grid {\n        gap: 20px;\n    }\n    .step-card,\n    .mission-card {\n        padding: 20px 10px;\n    }\n    .testimonial-box p {\n        font-size: 20px;\n        margin-bottom: 30px;\n    }\n    .goals-content h2 {\n        font-size: 28px;\n        margin-bottom: 16px;\n    }\n    .goals-content p {\n        font-size: 15px;\n        margin-bottom: 24px;\n    }\n    .hero-content {\n        gap: 40px;\n    }\n    .mission-content,\n    .shaping-content,\n    .history-content {\n        gap: 30px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
